(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../enums/metrics.js').dataType,
            require('../../../enums/metrics.js').collection,
            require('../../../enums/metrics.js').sources,
            require('../../../enums/metrics.js').sourceDetails,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.FacebookPublicPost = exportFn(
                RivalIQ.enums.dataType,
                RivalIQ.enums.collection,
                RivalIQ.enums.sources,
                RivalIQ.enums.sourceDetails,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(dataType, collection, sources, sourceDetails, DataSourceFilterGroupIds) {
        return {
            name: 'Facebook public post data',
            channelName: sourceDetails[sources.FACEBOOK].name,
            postName: sourceDetails[sources.FACEBOOK].postName,

            storageDimensions: [
                'postId'
            ],

            availableDimensions: [
                'companyId',
                'companySetId',
                'day', 'week', 'month',
                'dayOfWeek', 'hourOfDay',
                'mediaType',
                'reactionType',
                'engagementType',
                'postTagId',
                'hashtag',
                'keyword'
            ],

            fields: {
                postId: {
                    dataType: dataType.STRING
                },
                native_id: {
                    dataType: dataType.STRING
                },
                companyId: {
                    dataType: dataType.STRING
                },
                companyName: {
                    dataType: dataType.STRING
                },
                published_at: {
                    collection: collection.GENERAL,
                    dataType: dataType.DATE
                },
                engagement_total: {
                    name: 'Engagement Total',
                    collection: collection.ENGAGEMENT,
                    dataType: dataType.INTEGER
                },
                applause: {
                    name: 'Reactions',
                    collection: collection.ENGAGEMENT_DETAILS,
                    dataType: dataType.INTEGER
                },
                amplification: {
                    name: 'Shares',
                    collection: collection.ENGAGEMENT_DETAILS,
                    dataType: dataType.INTEGER
                },
                conversation: {
                    name: 'Comments',
                    collection: collection.ENGAGEMENT_DETAILS,
                    dataType: dataType.INTEGER
                },
                reactions: {
                    name: 'Reactions',
                    collection: collection.ENGAGEMENT_DETAILS,
                    dataType: dataType.INTEGER
                },
                likes: {
                    name: 'Likes',
                    collection: collection.ENGAGEMENT_DETAILS,
                    dataType: dataType.INTEGER
                },
                loves: {
                    name: 'Loves',
                    collection: collection.ENGAGEMENT_DETAILS,
                    dataType: dataType.INTEGER
                },
                hahas: {
                    name: 'Hahas',
                    collection: collection.ENGAGEMENT_DETAILS,
                    dataType: dataType.INTEGER
                },
                wows: {
                    name: 'Wows',
                    collection: collection.ENGAGEMENT_DETAILS,
                    dataType: dataType.INTEGER
                },
                sads: {
                    name: 'Sads',
                    collection: collection.ENGAGEMENT_DETAILS,
                    dataType: dataType.INTEGER
                },
                angrys: {
                    name: 'Angrys',
                    collection: collection.ENGAGEMENT_DETAILS,
                    dataType: dataType.INTEGER
                },
                presence_reach: {
                    name: 'Page Fans',
                    collection: collection.AUDIENCE,
                    dataType: dataType.INTEGER
                },
                engagement_rate_by_presence_reach: {
                    name: 'Engagement Rate by Page Fan',
                    collection: collection.ENGAGEMENT,
                    dataType: dataType.NUMERIC
                },
                has_hashtags: {
                    // 1 if this post has any hashtags, 0 otherwise.
                    dataType: dataType.INTEGER
                },
                engagement_rate_by_presence_reach_lift: {
                    name: 'Engagement Rate Lift',
                    collection: collection.ENGAGEMENT,
                    dataType: dataType.NUMERIC
                },
                other_posts_engagement_rate_by_presence_reach: {
                    name: 'Engagement Rate by Page Fan w/o tag',
                    collection: collection.ENGAGEMENT,
                    dataType: dataType.NUMERIC
                },
                video_views: {
                    name: 'Video Views',
                    collection: collection.VIDEO_VIEWS_DETAILS,
                    dataType: dataType.INTEGER
                },
                post_video_views: {
                    name: 'Video Views',
                    collection: collection.VIDEO_VIEWS_DETAILS,
                    dataType: dataType.INTEGER
                },
                message: {
                    dataType: dataType.STRING
                },
                postLink: {
                    name: 'Link',
                    dataType: dataType.STRING
                },
                mediaType: {
                    name: 'Type',
                    dataType: dataType.STRING
                },
                link: {
                    name: 'Link',
                    dataType: dataType.STRING
                },
                canonicalUrl: {
                    name: 'Posted URL',
                    dataType: dataType.STRING
                },
                linkTitle: {
                    name: 'Link Title',
                    dataType: dataType.STRING
                },
                postedTitle: {
                    name: 'Posted Title',
                    dataType: dataType.STRING
                },
                captured_at: {
                    name: 'Captured At',
                    dataType: dataType.DATE
                },
                platformImageUrl: {
                    dataType: dataType.STRING
                },
                imageUrl: {
                    dataType: dataType.STRING
                },
                linkDescription: {
                    name: 'Link Description',
                    dataType: dataType.STRING
                },
                presence_icon_url: {
                    dataType: dataType.STRING
                },
                presence_handle: {
                    name: 'Presence Handle',
                    collection: collection.GENERAL,
                    dataType: dataType.STRING
                },
                source: {
                    dataType: dataType.INTEGER
                },
                promoted_likelyhood: {
                    name: 'Likely Boosted',
                    collection: collection.ENGAGEMENT_DETAILS,
                    dataType: dataType.NUMERIC
                },
                estimated_impressions: {
                    name: 'Estimated Impressions',
                    collection: collection.GENERAL,
                    dataType: dataType.NUMERIC
                },
                engagement_rate_by_estimated_impression: {
                    name: 'Engagement Rate by Estimated Impression',
                    collection: collection.GENERAL,
                    dataType: dataType.NUMERIC
                }
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.company,
                DataSourceFilterGroupIds.timePeriod,
                DataSourceFilterGroupIds.source,
                DataSourceFilterGroupIds.publicPost,
                DataSourceFilterGroupIds.ordering
            ]
        };
    }
})();
